import { Button, Dropdown } from 'antd'
import {
  FileDown,
  ImagePlus,
  MoreVertical,
  Minimize2,
  Maximize2
} from 'lucide-react'
import { exportDocumentToCSV } from '../../utils/csv/export'
import { useFFEStore } from '../../store/ffeStore'

export const MoreDocumentControls = () => {
  const handleCSVExport = () => {
    exportDocumentToCSV(useFFEStore.getState().document)
  }

  const dropdownItems = [
    {
      key: 'export-csv',
      icon: <FileDown className="h-4 w-4" />,
      label: 'Export CSV',
      onClick: handleCSVExport
    },
    // {
    //   key: 'search',
    //   icon: <Search className="h-4 w-4" />,
    //   label: 'Search Document'
    // },
    // {
    //   key: 'revisions',
    //   icon: <History className="h-4 w-4" />,
    //   label: 'View revisions'
    // },
    // {
    //   key: 'save-revision',
    //   icon: <Save className="h-4 w-4" />,
    //   label: 'Save as revision'
    // },
    {
      key: 'collapse-all',
      icon: <Minimize2 className="h-4 w-4" />,
      label: 'Collapse all Groups',
      onClick: () => useFFEStore.getState().collapseAllGroups()
    },
    {
      key: 'expand-all',
      icon: <Maximize2 className="h-4 w-4" />,
      label: 'Expand all Groups',
      onClick: () => useFFEStore.getState().expandAllGroups()
    },
    {
      key: 'bulk-upload',
      icon: <ImagePlus className="h-4 w-4" />,
      label: 'Bulk Image Upload',
      onClick: () => useFFEStore.getState().setIsBulkImageDrawerOpen(true)
    }
  ]

  return (
    <Dropdown
      menu={{
        items: dropdownItems
      }}
      trigger={['click']}
    >
      <Button type="default" icon={<MoreVertical className="h-4 w-4" />} />
    </Dropdown>
  )
}
